
import React from 'react';


import logoFooter from '../images/logoIpiFooter.png';

import face from '../images/icon-face.png';
import insta from '../images/icon-insta.png';
import youtube from '../images/icon-yt.png';
import whatsapp from '../images/icon-wa.png';

import MenuFooter from './MenuFooter'

export class Footer extends React.Component {
	render() {

		return (
			<>
				<footer>
					<div className="blueGreenGradient">
						<div className="wrapContentIner">	
							<h2>¿Desea conocernos?</h2>
						</div>

						<div className="infoWrapper">
								<MenuFooter/>
						</div>
					</div>
					

					<div className="socialLinks">
						<div className="innerSocialLinks">
							<figure>
								<img src={logoFooter} alt="ipicim moravia preescolar primaria secundaria"/>
							</figure>
							<div className="socialLinksMenu">
								<span>Síguenos</span>
								<a href="https://www.facebook.com/ipicim" target="_blanc"><img src={face} alt="ipicim moravia preescolar primaria secundaria" /></a>
								<a href="https://www.instagram.com/ipicim/" target="_blanc"><img src={insta} alt="ipicim moravia preescolar primaria secundaria" /></a>
								<a href="https://www.youtube.com/user/ExpresaTvideos" target="_blanc"><img src={youtube} alt="ipicim moravia preescolar primaria secundaria" /></a>
								<a href="https://api.whatsapp.com/send/?phone=50671688408&text&type=phone_number&app_absent=0" target="_blanc"><img src={whatsapp} alt="ipicim moravia preescolar primaria secundaria" /></a>
							</div>

						</div>
						
					</div>

					<div className="bottom">
						<strong>&reg;&nbsp;</strong><span>Derechos Reservados IPICIM 2022</span>
					</div>

				</footer>
			</>
		)
	}
}

export default Footer